<template>
    <CollapsibleSection :name="name" :collapsable="collapsable">
        <UserOrganizationPresentation
            v-for="role in splitRoles[0]"
            :modelClass="role.modelClass"
            :name="role.name"
            :imageSrc="role.imageSrc"
            :url="role.modelUrl"
            :parentUrl="role.parentUrl"
            :parentName="role.parentName"
        />
        <VerticalSlideTransition :show="showMore">
            <UserOrganizationPresentation
                v-for="role in splitRoles[1]"
                :modelClass="role.modelClass"
                :name="role.name"
                :imageSrc="role.imageSrc"
                :url="role.modelUrl"
                :parentUrl="role.parentUrl"
                :parentName="role.parentName"
            />
        </VerticalSlideTransition>

        <div v-if="!collapsable && limitReached">
            <div
                class="w-full flex flex-col items-end pt-4 border-t border-border-darker/20"
            >
                <button
                    @click="showMore = !showMore"
                    class="flex items-center gap-x-2 underline-hover"
                >
                    <p
                        v-text="
                            showMore
                                ? $lang.get('Show less')
                                : $lang.get('Show more')
                        "
                    />
                    <transition name="fade" mode="out-in">
                        <component
                            :key="showMore ? 'showLess' : 'showMore'"
                            :is="showMore ? 'PhMinus' : 'PhPlus'"
                            class="size-6"
                        />
                    </transition>
                </button>
            </div>
        </div>
    </CollapsibleSection>
</template>

<script>
import ModelPreview from '@/Components/ModelComponents/ModelPreview.vue'
import VerticalSlideTransition from '@/Components/Transitions/VerticalSlideTransition.vue'
import UserOrganizationPresentation from '@/Components/ModelComponents/UserOrganizationPresentation.vue'
import CollapsibleSection from '@/Components/Utilities/CollapsibleSection.vue'
import { Link } from '@inertiajs/vue3'
import { PhCaretUp, PhMinus, PhPlus } from '@phosphor-icons/vue'

export default {
    name: 'RolePanel',

    components: {
        CollapsibleSection,
        ModelPreview,
        VerticalSlideTransition,
        UserOrganizationPresentation,
        Link,
        PhCaretUp,
        PhMinus,
        PhPlus,
    },

    props: {
        name: {
            type: String,
            required: true,
        },
        roles: {
            type: Array,
            required: true,
        },
        collapsable: {
            type: Boolean,
            default: false,
        },
        roleLimit: {
            type: Number,
            default: 2,
        },
    },

    data() {
        return {
            expanded: false,
            showMore: false,
        }
    },

    computed: {
        formattedRoles() {
            let model = null
            return this.roles
                .map((role) => {
                    model = role.user || role.organization
                    if (model) {
                        return {
                            ...role,
                            imageSrc: model?.first_image?.preview_url || null,
                            modelClass: model.modelClass,
                            modelUrl: this.$getModelUrl(model),
                            parentUrl:
                                model.modelClass == 'user' && model.organization
                                    ? this.$getModelUrl(model.organization)
                                    : null,
                            parentName:
                                model.modelClass == 'user'
                                    ? model?.organization?.name
                                    : null,
                            name: model.name,
                        }
                    }
                    return null
                })
                .filter((role) => role !== null)
        },

        /**
         * Returns an array with two arrays
         * If the panel is collapsable, the first array will contain all the roles
         * Otherwise it will contain roleLimit amount of roles and the rest will be in the second array
         *
         * This way we can let the user toggle the visibilty of the rest of the roles
         */
        splitRoles() {
            if (this.collapsable) {
                return [this.formattedRoles, []]
            }
            return [
                this.formattedRoles.slice(0, this.roleLimit),
                this.formattedRoles.slice(this.roleLimit),
            ]
        },

        limitReached() {
            return this.roles.length > this.roleLimit
        },
    },
}
</script>
